import type {
  IframeCloseResponse,
  IframeConnectRequest,
  IframeErrorResponse,
  IframeMessageResponse,
  IframeOpenResponse,
} from '@/common/interop/iframe';
import { directoryParamName, namespaceParamName } from '@/common/directories';
import { postMessageToPort } from '../../common/port';

export function createWebSocket(
  port: MessagePort,
  { directory, namespace, instanceId }: IframeConnectRequest,
) {
  const path = `/interop/?instanceId=${instanceId}&${directoryParamName}=${directory}&${namespaceParamName}=${namespace}`;
  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  const host = window.location.host;
  const url = `${protocol}${host}${path}`;

  const ws = new WebSocket(url);
  ws.onopen = () =>
    postMessageToPort<IframeOpenResponse>(port, { topic: 'open' });
  ws.onmessage = ({ data }) =>
    postMessageToPort<IframeMessageResponse>(port, { topic: 'message', data });
  ws.onerror = () =>
    postMessageToPort<IframeErrorResponse>(port, { topic: 'error' });
  ws.onclose = ({ code }) =>
    postMessageToPort<IframeCloseResponse>(port, {
      topic: 'close',
      code,
      directory,
      namespace,
      instanceId,
    });
  return ws;
}
